export default "__VITE_ASSET__2a339bf6__"